import {
  GET_USER_SMART_VIEWS,
  GET_USER_SMART_VIEWS_SUCCESS,
  GET_USER_SMART_VIEWS_ERROR,
  CREATE_USER_SMART_VIEWS,
  CREATE_USER_SMART_VIEWS_SUCCESS,
  CREATE_USER_SMART_VIEWS_ERROR,
  UPDATE_USER_SMART_VIEWS,
  UPDATE_USER_SMART_VIEWS_SUCCESS,
  UPDATE_USER_SMART_VIEWS_ERROR,
  DELETE_USER_SMART_VIEWS,
  DELETE_USER_SMART_VIEWS_SUCCESS,
  DELETE_USER_SMART_VIEWS_ERROR,
  RESET_LAST_USER_SMART_VIEW_ACTION
} from "./actionTypes"

export const getUserSmartViews = () => {
  return {
    type: GET_USER_SMART_VIEWS,
  }
}

export const getUserSmartViewsSuccess = user_smart_views => {
  return {
    type: GET_USER_SMART_VIEWS_SUCCESS,
    payload: user_smart_views,
  }
}

export const getUserSmartViewsError = error => {
  return {
    type: GET_USER_SMART_VIEWS_ERROR,
    payload: error,
  }
}

export const createUserSmartViews = (payload) => {
  return {
    type: CREATE_USER_SMART_VIEWS,
    payload: payload
  }
}

export const createUserSmartViewsSuccess = user_smart_views => {
  return {
    type: CREATE_USER_SMART_VIEWS_SUCCESS,
    payload: user_smart_views
  }
}

export const createUserSmartViewsError = error => {
  return {
    type: CREATE_USER_SMART_VIEWS_ERROR,
    payload: error
  }
}

export const updateUserSmartViews = (payload) => {
  return {
    type: UPDATE_USER_SMART_VIEWS,
    payload: payload
  }
}

export const updateUserSmartViewsSuccess = user_smart_views => {
  return {
    type: UPDATE_USER_SMART_VIEWS_SUCCESS,
    payload: user_smart_views
  }
}

export const updateUserSmartViewsError = error => {
  return {
    type: UPDATE_USER_SMART_VIEWS_ERROR,
    payload: error
  }
}

export const deleteUserSmartViews = (payload) => {
  return {
    type: DELETE_USER_SMART_VIEWS,
    payload: payload
  }
}

export const deleteUserSmartViewsSuccess = user_smart_views => {
  return {
    type: DELETE_USER_SMART_VIEWS_SUCCESS,
    payload: user_smart_views
  }
}

export const deleteUserSmartViewsError = error => {
  return {
    type: DELETE_USER_SMART_VIEWS_ERROR,
    payload: error
  }
}

export const resetLastUserSmartViewAction = () => {
  return {
    type: RESET_LAST_USER_SMART_VIEW_ACTION
  }
}